import { IStandardError } from "../../shared/types/error.types";

export const GENERIC_ERROR_MESSAGE =
  "We are experiencing technical difficulties. Please try again later.";

const INTERNAL_SERVER_ERROR: IStandardError = {
  code: 500,
  message: "Internal Server Error",
  displayMessage: "Internal Server Error.",
  isCCSOStandardError: true,
};

const BAD_REQUEST_ERROR: IStandardError = {
  code: 400,
  message: "Bad Request",
  displayMessage: "Bad Request.",
  isCCSOStandardError: true,
};

const UNAUTHORIZED_ERROR: IStandardError = {
  code: 401,
  message: "Unauthorized",
  displayMessage: "Unauthorized.",
  isCCSOStandardError: true,
};

const NOT_FOUND_ERROR: IStandardError = {
  code: 404,
  message: "Not Found",
  displayMessage: "Not Found.",
  isCCSOStandardError: true,
};

export default {
  INTERNAL_SERVER_ERROR,
  GENERIC_ERROR_MESSAGE,
  BAD_REQUEST_ERROR,
  UNAUTHORIZED_ERROR,
  NOT_FOUND_ERROR,
};
